import { reviewApi } from '../api/review'
import { useReviewStore } from '../stores/reviewStore'
import { downscaleForUpload } from './downscalePhoto'

/**
 * 방금 넣은 사진을 백그라운드로 미리 올려둔다.
 *
 * 왜 미리 올리나
 * -------------
 * 예전에는 사진을 리뷰 저장 요청에 base64로 실어 보냈다. 실측으로 사진 2장이면
 * 요청 본문이 1.55MB, 저장에 1.82초가 걸렸고 그중 1.37초(75%)가 업로드를
 * 기다리는 시간이었다. 사용자는 A/B 비교를 다 끝낸 뒤 그 시간을 그대로 기다렸다.
 *
 * 사진을 고른 시점과 저장 시점 사이에는 여유가 있다 — 실측한 12건에서 가장 짧은
 * 간격이 6초였고 대부분 20초를 넘었다. 그 사이에 올려두면 마지막 저장 요청은
 * 주소만 실어 보내면 되고, 사진 없는 리뷰와 같은 0.07초로 끝난다.
 *
 * 서버 부담도 준다. php-fpm 동시 처리가 10개뿐이라 1.8초짜리 요청이 한 칸을
 * 오래 잡는 것 자체가 병목이다.
 *
 * 실패하면 조용히 넘어간다
 * ----------------------
 * 주소를 못 받으면 아무것도 안 한다. 저장할 때 주소가 없는 사진은 예전처럼
 * 본문에 실어 보내므로 동작은 그대로다 — 느릴 뿐이다.
 */
export function preuploadPhoto(photoId: string, dataUrl: string): void {
  if (!dataUrl.startsWith('data:')) return

  void (async () => {
    try {
      const url = await reviewApi.uploadPhoto(await downscaleForUpload(dataUrl))
      if (!url) return

      // 올리는 동안 사용자가 그 사진을 지웠거나 다시 편집했을 수 있다.
      // 지금 목록에 같은 id가 남아 있을 때만 주소를 붙인다.
      const { photos, setPhotos } = useReviewStore.getState()
      if (!photos.some((p) => p.id === photoId)) return
      setPhotos(
        photos.map((p) => (p.id === photoId ? { ...p, uploadedUrl: url } : p))
      )
    } catch {
      // 조용히 넘어간다 (위 주석 참고)
    }
  })()
}
